module.exports = __webpack_public_path__ + "media/images/common-nav/rv-parks/florida-4fef30133f8e1fbc4682a5b971de0bf3.jpg";